exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".setting-header[data-v-3cbc7c7b]{background-color:#fbfbfb}.setting-body[data-v-3cbc7c7b]{background-color:#fdfdfd}input[data-v-3cbc7c7b],textarea[data-v-3cbc7c7b]{border-style:solid}.token_password_toggle[data-v-3cbc7c7b]{position:absolute;margin-top:-30px;right:20px}", ""]);

// exports
